import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faFileLines, 
    faUserFriends, 
    faUsersRectangle, 
    faFileEdit,
    faList,
    faUsersViewfinder,
    faFileContract,
    faBuildingUser,
    faChalkboardUser,
    faFolderOpen,
    faUserTag
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import pathConstant from '../../../utils/path.constant';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import React from 'react';

export function ManageUsersTab () {
    return (
        <div>
            <Link to={pathConstant.MANAGE_USERS}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faUserFriends} />
                    <p>Manage Users</p>
                </div>
            </Link>
        </div>
    );
}

export function ManageDepartmentTab () {
    return (
        <div>
            <Link to={pathConstant.MANAGE_DEPARTMENTS}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faUsersRectangle} />
                    <p>Manage Departments</p>
                </div>
            </Link>
        </div>
    );
}

export function ManageJDLTab () {
    return (
        <>
            <Link to={pathConstant.MANAGE_JDL}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faFileLines} />
                    <p>Manage JDL</p>
                </div>
            </Link>
        </>
    );
}

export function AttendanceTab () {
    return (
        <>
            <Link to={pathConstant.USER_ATTENDANCE}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faClock} />
                    <p>Attendance</p>
                </div>
            </Link>
        </>
    );
}

export function FormatCvTab () {
    return (
        <>
            <Link to={pathConstant.FORMAT_CV}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faFileEdit} />
                    <p>Format CV</p>
                </div>
            </Link>
        </>
    );
}

export function RequirementsTab () {
    return (
        <>
            <Link to={pathConstant.REQUIREMENTS}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faList} />
                    <p>Requirements</p>
                </div>
            </Link>
        </>
    );
}

export function HrManagementTab () {
    return (
        <>
            <Link to={pathConstant.HR_MANAGEMENT_EMPLOYEE_DATA}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faUsersViewfinder} />
                    <p>HR Management</p>
                </div>
            </Link>
        </>
    );
}

export function LeaveEmpTab () {
    return (
        <>
            <Link to={pathConstant.LEAVE_TAB}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faFileContract} />
                    <p>Leave</p>
                </div>
            </Link>
        </>
    );
}

export function CstDashboard () {
    return (
        <>
            <Link to={pathConstant.CST_DASHBOARD} target='_blank' rel='noopener noreferrer' >
                <div className='tab'>
                    <FontAwesomeIcon icon={faBuildingUser} />
                    <p>CST Dashboard</p>
                </div>
            </Link>
        </>
    );
}

export function CstRevenueTarget () {
    return (
        <>
            <Link to={pathConstant.CST_REVENUE_TARGET}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faChalkboardUser} />
                    <p>Revenue Tracker</p>
                </div>
            </Link>
        </>
    );
}

interface pipelineSidebarProps {
    full_access : boolean
}

export const CddPipeLine : React.FC<pipelineSidebarProps> = ({ full_access }) => {
    return (
        <>
            <Link to={full_access ? pathConstant.CST_RECRUITERS_PIPELINE : pathConstant.CDD_PIPELINE}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faFolderOpen} />
                    <p>CIP Pipeline</p>
                </div>
            </Link>
        </>
    );
}

export function CandidateProfileTab () {
    return (
        <>
            <Link to={pathConstant.CANDIDATE_PROFILE}>
                <div className='tab'>
                    <FontAwesomeIcon icon={faUserTag} />
                    <p>Candidate's profile</p>
                </div>
            </Link>
        </>
    );
}